/* eslint-disable no-nested-ternary */

import { trackNumberTest } from '@/utils';
import { SHIPPING_CARRIER } from '@/constants';
import { Form, Select, Input } from 'antd';
import classes from './index.module.css';

export const TrackingFormItem = () => (
  <div className={classes.tracking_form}>
    <Form.Item
      name="trackingNumber"
      label="Tracking number"
      style={{ marginBottom: 0, width: '50%' }}
      rules={[{ required: true, message: 'Please enter tracking number' }, {
        validator: (rule, value) => {
          if (!value) {
            return Promise.reject(new Error());
          }
          if (!value || (value && !trackNumberTest(value))) {
            return Promise.reject(new Error('Please enter a valid tracking number'));
          }
          return Promise.resolve();
        },
      }]}
    >
      <Input style={{ width: '100%' }} />
    </Form.Item>
    <Form.Item name="carrier" label="Shipping carrier" style={{ marginBottom: 0, width: '50%' }} rules={[{ required: true }]}>
      <Select style={{ width: '100%' }} options={SHIPPING_CARRIER}>
      </Select>
    </Form.Item>
  </div>

);
